import { observer } from 'mobx-react-lite';
import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import DataRow from 'owa-calendar-forms-common/lib/components/DataRow';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import OnlineMeetingLink from 'owa-online-meeting/lib/component/OnlineMeetingLink';
import { OnlineMeetingProviderType } from 'owa-online-meeting/lib/utils/OnlineMeetingProviderType';
import * as React from 'react';
import { getIconFromProviderName } from 'owa-online-meeting/lib/utils/onlineMeetingHelper';

const styles = require('./CalendarItemPeek.scss');

interface PeekEventOnlineMeetingDetailsRowProps {
    item: CalendarEvent;
    colorScheme: ColorScheme;
    actionSource: ViewType;
}

export default observer(function PeekEventOnlineMeetingDetailsRow(
    props: PeekEventOnlineMeetingDetailsRowProps
) {
    const { item, colorScheme, actionSource } = props;

    const onOnlineMeetingLinkClicked = React.useCallback(() => {
        userInteractionAction('LinkClicked', actionSource, item.IsOrganizer, item.IsMeeting);

        // We log this to measure specifically the user interaction with the Join button or link
        // We don't want to interfere with the 'LinkClicked' action type
        userInteractionAction('JoinOnlineMeeting', actionSource, item.IsOrganizer, item.IsMeeting, [
            item.OnlineMeetingProvider,
        ]);
    }, [actionSource, item.IsOrganizer, item.IsMeeting]);

    return (
        <DataRow
            className={styles.onlineMeetingRow}
            iconName={getIconFromProviderName(
                item.OnlineMeetingProvider as OnlineMeetingProviderType
            )}
            iconClassName={styles.onlineMeetingIcon}
            iconContainerClassName={styles.iconContainer}
            childrenClassName={styles.onlineMeetingContainer}>
            <OnlineMeetingLink
                calendarColorScheme={colorScheme}
                event={item}
                onLinkClickedCallback={onOnlineMeetingLinkClicked}
                hideIcon={true}
                joinOnlineLinkClassName={styles.joinOnlineLink}
                joinOnlineLinkContainerClassName={styles.joinOnlineLinkContainer}
            />
        </DataRow>
    );
});
